import gButton from "@/components/g-button/g-button.vue";
import gCard from "@/components/g-card/g-card.vue";
import gPdf from "@/components/g-pdf/g-pdf.vue";
import PedidoDetalhesViewModel from "@/shared/view-models/PedidoDetalhesViewModel";
import InstrucoesCarregamentoViewModel from "@/shared/view-models/InstrucoesCarregamentoViewModel";
import PedidoDesdobramentoViewModel from "@/shared/view-models/PedidoDesdobramentoViewModel";
import Tools from "@/shared/services/tools";
import { defineComponent } from "vue";

const name = 'InstrucoesCarregamentoPedidoCanceladosLiquidados'

export default defineComponent({
  name,

  components:{
    "g-button": gButton,
    "g-card": gCard,
    "g-pdf": gPdf,
  },

  props: { },

  mounted() {
    this.GetDetalhesDeInstrucoesDeCarregamento();
    this.GetInstrucoesDeCarregamento();
    this.getPedidoDesdobramento();
   },

  updated() { },

  data() {
    return {
      novoPedidoDetalhes : new PedidoDetalhesViewModel(),
      novoInstrucoesCarregamento : new InstrucoesCarregamentoViewModel(),
      instrucoesCarregamentoArray: [],
      pedidoDesdobramento : new PedidoDesdobramentoViewModel(),
    }

  },

  methods: {
    voltar() {

      this.$router.back()

    },


    GetDetalhesDeInstrucoesDeCarregamento() {
      this.axios({
        method: 'get',
        url: process.env.VUE_APP_WEB_API + `Pedido/GetDetalhesDeInstrucoesDeCarregamento/${this.$route.params.id}/${this.$route.params.numeroParcela}`,
      })
        .then((response) => {
          Tools.objectCustomAssign(this.novoPedidoDetalhes, Tools.captalizeKeys(response.data.data))
        })
        .catch(() => {
        });
    },


    GetInstrucoesDeCarregamento() {
      this.axios({
        method: 'get',
        url: process.env.VUE_APP_WEB_API + `Pedido/GetInstrucoesDeCarregamento/${this.$route.params.id}/${this.$route.params.numeroParcela}`,
      })
        .then((response) => {
          if (Array.isArray(response.data.data)) {
            this.instrucoesCarregamentoArray = [];
            response.data.data.forEach(item => {
              const instrucao = new InstrucoesCarregamentoViewModel();
              Tools.objectCustomAssign(instrucao, Tools.captalizeKeys(item));
              this.instrucoesCarregamentoArray.push(instrucao);
            });
            
            if (this.instrucoesCarregamentoArray.length > 0) {
              Tools.objectCustomAssign(this.novoInstrucoesCarregamento, this.instrucoesCarregamentoArray[0]);
            }
          } else {
            Tools.objectCustomAssign(this.novoInstrucoesCarregamento, Tools.captalizeKeys(response.data.data));
          }
        })
        .catch(() => {
        });
    },

    getPedidoDesdobramento() {
      this.$isLoading(true)
      this.axios({
        method: 'get',
        url: process.env.VUE_APP_WEB_API + `Pedido/GetPedidoDesdobramento/${this.$route.params.id}/${this.$route.params.numeroParcela}`,
      })
        .then((response) => {
          Tools.objectCustomAssign(this.pedidoDesdobramento, Tools.captalizeKeys(response.data.data))
        })
        .catch(() => {
        }).finally(() => this.$isLoading(false))
    },
  },


  computed: { }
});